// Status da empresa — o filtro do Embarcador (#80140 / #81586).
//
// Espelha utils/vehicleStatus.js, que serve as três listagens de veículo, mas
// concordando no feminino: a entidade aqui é a EMPRESA.
//
// Vai para a API como `q[company_status]` — não `entity_status_id`, que este
// endpoint não conhece. A linha volta com `companyStatus` porque a listagem já
// pede `methods: ['company']`.

export const COMPANY_STATUS = {
  ENABLED: 1,
  DISABLED: 2
}

export const COMPANY_STATUS_OPTIONS = [
  { id: COMPANY_STATUS.ENABLED, friendlyName: 'Ativo' },
  { id: COMPANY_STATUS.DISABLED, friendlyName: 'Inativo' }
]

// A empresa foi excluída — não é um entity_status, e o valor é textual.
export const COMPANY_STATUS_DELETED = 'deleted'

// As opções do filtro, no formato [label, value] que o Filter usa.
export const COMPANY_STATUS_FILTER_TABLE = [
  ['Todas', ''],
  ['Ativa', String(COMPANY_STATUS.ENABLED)],
  ['Inativa', String(COMPANY_STATUS.DISABLED)],
  ['Excluídas', COMPANY_STATUS_DELETED]
]

// O rótulo de uma linha da tabela — singular. Traço só quando o
// `methods: ['company']` não foi pedido: excluída tem nome próprio, não é a
// ausência de valor.
export function companyStatusRowLabel(value) {
  if (value === COMPANY_STATUS_DELETED) return 'Excluída'
  if (value === String(COMPANY_STATUS.ENABLED)) return 'Ativa'
  if (value === String(COMPANY_STATUS.DISABLED)) return 'Inativa'
  return '-'
}
